// extracted by mini-css-extract-plugin
export default {"clickableCol":"src-views-common-components-SDSColumn-SDSColumn__clickableCol--HW5Xk"};